import { Link } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

/**
 * Header component for the application.
 * Displays branding and utility options such as theme toggle and user menu.
 */
export function Header() {
  return (
    <header aria-label="Main navigation" className="sticky top-0 z-50 w-full h-14 bg-background border-b">
      <div className="container max-w-screen-2xl mx-auto h-full flex items-center gap-4 px-4">
        {/* Branding Section */}
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/assets/images/Gather_Icon.svg"
            alt="QS Tools"
            className="h-6 w-6"
          />
          <span className="font-bold hidden sm:inline-block">QS Tools</span>
        </Link>

        {/* Spacer to push items to the right */}
        <div className="flex-1" />

        {/* Utility Actions */}
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
